import { safeResolve } from 'src/app/shared/modules/graphql/rxjs';
import { Injectable } from "@angular/core";
import { Apollo } from "apollo-angular";
import { Observable } from "rxjs";
import { IApiInvestigationMetricsClientContactConnection, IApiInvestigationMetricsFilter } from '../../../../types/types';
import { IGqlBaseOptions } from '../../../../interfaces';
import { connectionQuery } from '../../../../helpers.class';
import { investigationMetricsClientContactConnection } from './investigation-metrics-contact.operation';

@Injectable()
export class GqlInvestigationMetricsContactService {
  public constructor(
    private apollo: Apollo
  ) { }

  public get(filters: IApiInvestigationMetricsFilter[], options: IGqlBaseOptions): Observable<IApiInvestigationMetricsClientContactConnection> {
    return this.apollo.query(connectionQuery(investigationMetricsClientContactConnection, filters, options)).pipe(
      safeResolve(true)
    );
  }

}
